// web/src/shared/api.ts
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export { API_BASE_URL as BASE_URL };

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

/**
 * Fetch CSRF token — throws if null
 */
export const fetchCsrfToken = async (): Promise<string> => {
  const res = await api.get('/api/csrf-token');
  const token = res.data.csrfToken;
  if (!token) {
    throw new Error('CSRF token is missing');
  }
  return token;
};

// Auto-add CSRF to POST/PUT/DELETE
api.interceptors.request.use(async (config) => {
  if (['post', 'put', 'delete'].includes(config.method!.toLowerCase())) {
    try {
      const token = await fetchCsrfToken();
      config.headers['X-CSRF-Token'] = token;
      config.data = { ...config.data, _csrf: token };
    } catch (err) {
      console.error('Failed to attach CSRF token:', err);
    }
  }
  return config;
});

export default api;
